import React from 'react';
import type { TimeCellProps } from './types';
import { TimeCellRoot } from './styles';

const TimeCell = (props: TimeCellProps) => {
  const { isSelected, disabled, error, type = 'button', onClick, children, ...rest } = props;
  const canExposeSelection = !error && !disabled;

  return (
    <TimeCellRoot
      {...rest}
      type={type}
      isSelected={isSelected}
      error={error}
      disabled={disabled}
      aria-pressed={canExposeSelection ? isSelected : undefined}
      data-cy={error ? 'unavailableTimeCard' : 'availableTimeCard'}
      onClick={onClick}
    >
      {children}
    </TimeCellRoot>
  );
};

export default TimeCell;
